<div class="mb-27 mct-grid neo-config-grid mct-gap-27-8">
  <div>{{ 'dashboard.config.override-date-range' | translate | titlecase }}</div>
  <div><p-checkbox binary="true" [(ngModel)]="config.OverrideDateRange" (onChange)="overrideDatesChanged()"></p-checkbox></div>
</div>
<div [hidden]="!config.OverrideDateRange" class="mb-27">
  <div class="mct-grid neo-config-grid mct-gap-27-8">
    <div class="pl-27">{{ 'common.start-date' | translate | titlecase }}</div>
    <div>
      <wl-date-selector [(ngModel)]="config.StartDate" [disabled]="!config.OverrideDateRange" appendTo="body"></wl-date-selector>
    </div>
    <div class="pl-27">{{ 'common.end-date' | translate | titlecase }}</div>
    <div>
      <wl-date-selector [(ngModel)]="config.EndDate" [disabled]="!config.OverrideDateRange" appendTo="body"></wl-date-selector>
    </div>
  </div>
</div>
<div class="mct-grid neo-config-grid mct-gap-27-8">
  <div>{{ 'dashboard.config.show-upcoming-events' | translate | titlecase }}</div>
  <div><p-checkbox binary="true" [(ngModel)]="config.ShowUpcomingEvents"></p-checkbox></div>
  <div>{{ 'dashboard.config.show-membership' | translate | titlecase }}</div>
  <div><p-checkbox binary="true" [(ngModel)]="config.ShowMembershipActitiyTotals"></p-checkbox></div>
  <div>{{ 'dashboard.config.show-finance' | translate | titlecase }}</div>
  <div><p-checkbox binary="true" [(ngModel)]="config.ShowFinance"></p-checkbox></div>
  <div>{{ 'dashboard.config.show-my-reports' | translate | titlecase }}</div>
  <div><p-checkbox binary="true" [(ngModel)]="config.ShowMyReports"></p-checkbox></div>
  <div>{{ 'dashboard.config.show-my-tasks' | translate | titlecase }}</div>
  <div><p-checkbox binary="true" [(ngModel)]="config.ShowMyTasks"></p-checkbox></div>
  <div [hidden]="!config.ShowMyTasks" class="pl-27">{{ 'dashboard.config.move-my-tasks' | translate | titlecase }}</div>
  <div [hidden]="!config.ShowMyTasks"><p-checkbox binary="true" [(ngModel)]="config.MoveMyTasksToTop"></p-checkbox></div>
  <div>{{ 'dashboard.config.show-my-sales-opps' | translate | titlecase }}</div>
  <div><p-checkbox binary="true" [(ngModel)]="config.ShowMySalesOpportunities"></p-checkbox></div>
  <div [hidden]="!config.ShowMySalesOpportunities" class="pl-27">{{ 'dashboard.config.move-my-sales-opps' | translate | titlecase }}</div>
  <div [hidden]="!config.ShowMySalesOpportunities">
    <p-checkbox binary="true" [(ngModel)]="config.MoveMySalesOpportunitiesToTop"></p-checkbox>
  </div>
</div>
